import { Guid } from "guid-typescript";

export class BranchDetails {
  public DealerCode: string;
  public BranchCode: string;
  public ClientId: Guid;
  public BranchName: string;
  public BranchAddress: string;
}
